import { FastingDurationPopupComponent } from "./components/fasting-duration-popup/fasting-duration-popup.component";
import { FastingAlarmPopupComponent } from "./components/fasting-alarm-popup/fasting-alarm-popup.component";
import { OnSignupFreePlanComponent } from "./components/on-signup-free-plan/on-signup-free-plan.component";
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { NativeStorage } from "@ionic-native/native-storage/ngx";
import { GooglePlus } from "@ionic-native/google-plus/ngx";
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AuthInterceptor } from "./auth.interceptor";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { Globalization } from "@ionic-native/globalization/ngx";
import { ScrollDirective } from "./scroll.directive";
// import { ComponentsModule } from './components/components.module';
import { IonicStorageModule } from "@ionic/storage";
import { Health } from "@ionic-native/health/ngx";
import { BackButtonDisableModule } from "angular-disable-browser-back-button";

import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { environment } from "../environments/environment";
import { ServiceWorkerModule } from "@angular/service-worker";
// import { Facebook } from "@ionic-native/facebook/ngx";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
//import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Network } from "@ionic-native/network/ngx";
import { Market } from "@ionic-native/market/ngx";
import { SignInWithApple } from "@awesome-cordova-plugins/sign-in-with-apple/ngx";
import { InAppPurchase } from "@ionic-native/in-app-purchase/ngx";
import { InAppService } from "./inapp.service";
import { InAppPurchase2 } from "@ionic-native/in-app-purchase-2/ngx";
import { Keyboard } from "@ionic-native/keyboard/ngx";
import { HTTP } from "@ionic-native/http/ngx";
// import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import { DeviceDetectorService } from "ngx-device-detector";
import { Device } from "@ionic-native/device/ngx";
// import { IonicNativePlugin } from '@ionic-native/core';
// import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { AndroidPermissions } from "@ionic-native/android-permissions/ngx";
import { RoundProgressModule } from "angular-svg-round-progressbar";
import { FirebaseX } from "@ionic-native/firebase-x/ngx";
import { Diagnostic } from "@ionic-native/diagnostic/ngx";
// import { OfferPopupComponent } ''
import { OfferPopupComponent } from "../app/components/offer-popup/offer-popup.component";
import { PaymentSuccessPopupComponent } from "../app/components/payment-success-popup/payment-success-popup.component";
import { NutriSelectSlotComponent } from "../app/components/nutri-select-slot/nutri-select-slot.component";
import { PaymentSubscribePopupComponent } from "../app/components/payment-subscribe-popup/payment-subscribe-popup.component";
import { RatingPopupComponent } from "../app/components/rating-popup/rating-popup.component";
import { SelectPlanPopupComponent } from "../app/components/select-plan-popup/select-plan-popup.component";
import { PlanInfoPopupComponent } from "../app/components/plan-info-popup/plan-info-popup.component";
import { FeatureExplanationPopupComponent } from "../app/components/feature-explanation-popup/feature-explanation-popup.component";
import { NoInternetComponent } from "../app/components/no-internet/no-internet.component";
import { PurchasePlanPopupComponent } from "../app/components/purchase-plan-popup/purchase-plan-popup.component";
import { UsetDetailsPopupComponent } from "../app/components/user-details-popup/user-details-popup.component";
import { NgCircleProgressModule } from "ng-circle-progress";
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { IonicRatingModule } from "ionic-rating";
import { IonIntlTelInputModule } from "ion-intl-tel-input";
import { File } from "@ionic-native/file/ngx";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { DecimalPipe } from "@angular/common";
import { CaloriesCounterInfoComponent } from "../app/components/calories-counter-info/calories-counter-info.component";
import { Media } from "@ionic-native/media/ngx";
import { GaugeChartModule } from "angular-gauge-chart";
import { SharedModule } from "./shared/shared.module";
import { SocialSharing } from "@awesome-cordova-plugins/social-sharing/ngx";
import { NutriSelectRecipeComponent } from "../app/components/nutri-select-recipe/nutri-select-recipe.component";
import { AddressThanksComponent } from "../app/components/address-thanks/address-thanks.component";
import { Geolocation } from "@ionic-native/geolocation/ngx";
import { NativeGeocoder } from "@ionic-native/native-geocoder/ngx";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BarcodeScanner } from "@awesome-cordova-plugins/barcode-scanner/ngx";
import { NgChartjsModule } from "ng-chartjs";
import * as ChartAnnotation from "chartjs-plugin-annotation";
import { AppVersion } from "@awesome-cordova-plugins/app-version/ngx";
import { Deeplinks } from "@awesome-cordova-plugins/deeplinks/ngx";


@NgModule({
  declarations: [
    AppComponent,
    OfferPopupComponent,
    PaymentSuccessPopupComponent,
    PaymentSubscribePopupComponent,
    UsetDetailsPopupComponent,
    PurchasePlanPopupComponent,
    ScrollDirective,
    RatingPopupComponent,
    SelectPlanPopupComponent,
    PlanInfoPopupComponent,
    FeatureExplanationPopupComponent,
    NoInternetComponent,
    CaloriesCounterInfoComponent,
    NutriSelectSlotComponent,
    FastingAlarmPopupComponent,
    FastingDurationPopupComponent,
    OnSignupFreePlanComponent,
    NutriSelectRecipeComponent,
    AddressThanksComponent,
   
  ],
  // entryComponents:[IonicNativePlugin],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    AngularFireAuthModule,
    NgChartjsModule.registerPlugin([ChartAnnotation]),
    // LaunchReview,
    AngularFireModule.initializeApp(environment.firebase),
    BackButtonDisableModule.forRoot({
      preserveScrollPosition: true,
    }),
    AppRoutingModule,
    HttpClientModule,
    IonicRatingModule,
    GaugeChartModule,
    IonicStorageModule.forRoot({
      name: "__mydb",
      driverOrder: ["indexeddb", "sqlite", "websql", "localstorage"],
    }),
    // ComponentsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoader,
        deps: [HttpClient],
      },
    }),
    RoundProgressModule,
    NgCircleProgressModule,
    IonIntlTelInputModule,
    SharedModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
  ],
  providers: [
    Geolocation,
    NativeGeocoder,
    Market,
    StatusBar,
    SplashScreen,
    Health,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    NativeStorage,
    GooglePlus,
    TranslateModule,
    Globalization,
    TranslateService,
    InAppService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    
    InAppBrowser,
    Network,
    SignInWithApple,
    InAppPurchase,
    HTTP,
    InAppPurchase2,
    AppVersion,
    // Keyboard,
    // Push,
    Keyboard,
    DeviceDetectorService,
    Device,
    AndroidPermissions,
    FirebaseX,
    Diagnostic,
    File,
    FileOpener,
    DecimalPipe,
    Media,
    SocialSharing,
    BarcodeScanner,
    Deeplinks,
    // AdMob
    // SocialSharing
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
export function translateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "./assets/i18n/", ".json");
}
